module.exports = __webpack_public_path__ + "static/media/fragile.64362906.svg";